import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordQrIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path
        d="M5.19638 1.00012C3.51826 1.03849 2.53808 1.19879 1.86837 1.8685C1.19867 2.5382 1.03837 3.51838 1 5.1965M8.80362 1.00012C10.4817 1.03849 11.4619 1.19879 12.1316 1.8685C12.8013 2.5382 12.9616 3.51838 13 5.1965M8.80362 13.0001C10.4817 12.9618 11.4619 12.8015 12.1316 12.1317C12.8013 11.462 12.9616 10.4819 13 8.80374M5.19638 13.0001C3.51826 12.9618 2.53808 12.8015 1.86837 12.1317C1.19867 11.462 1.03837 10.4819 1 8.80374"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99988 4.00012H10.0053"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60039 3.40015V5.20015C7.60039 6.33152 7.60039 6.8972 7.24892 7.24867C6.89745 7.60015 6.33176 7.60015 5.20039 7.60015H3.40039"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      <path
        d="M3.57613 3.57588C3.40039 3.75162 3.40039 4.03446 3.40039 4.60015C3.40039 5.16583 3.40039 5.44867 3.57613 5.62441M3.57613 3.57588C3.75186 3.40015 4.03471 3.40015 4.60039 3.40015C5.16608 3.40015 5.44892 3.40015 5.62465 3.57588M3.57613 3.57588C3.57613 3.57588 3.57613 3.57588 3.57613 3.57588ZM3.57613 5.62441C3.75186 5.80015 4.03471 5.80015 4.60039 5.80015C5.16608 5.80015 5.44892 5.80015 5.62465 5.62441M3.57613 5.62441C3.57613 5.62441 3.57613 5.62441 3.57613 5.62441ZM5.62465 5.62441C5.80039 5.44867 5.80039 5.16583 5.80039 4.60015C5.80039 4.03446 5.80039 3.75162 5.62465 3.57588M5.62465 5.62441C5.62465 5.62441 5.62465 5.62441 5.62465 5.62441ZM5.62465 3.57588C5.62465 3.57588 5.62465 3.57588 5.62465 3.57588Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
      />
      <path
        d="M9.99922 8.80017C10.2821 8.80017 10.4235 8.80017 10.5114 8.88804C10.5992 8.97591 10.5992 9.11733 10.5992 9.40017V10.0002C10.5992 10.283 10.5992 10.4244 10.5114 10.5123C10.4235 10.6002 10.2821 10.6002 9.99922 10.6002H8.79922C8.51638 10.6002 8.37495 10.6002 8.28709 10.5123C8.19922 10.4244 8.19922 10.283 8.19922 10.0002L8.19922 9.40017C8.19922 9.11733 8.19922 8.97591 8.28709 8.88804C8.37495 8.80017 8.51638 8.80017 8.79922 8.80017L9.99922 8.80017Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
      />
      <path
        d="M3.40039 10.6001H6.40039"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      <path
        d="M10 5.80017L10 7.00017"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="0.9"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default BordQrIcon;
